// Whether the Pending invites modal is open (ART-239).
//
// The `teamPanel.ts` shape, with one difference: there is no single shell to consume a request here. The modal is
// opened from the account dropdown in THREE shells, from the mobile account sheet, and from a seat_invite bell row
// or push (`/?invites=open`), and an invite can arrive for a person in any of them — so the modal is mounted ONCE,
// at the router root (`PendingInvitesHost`), and this store IS its open state. UI state only.
import { create } from "zustand";
import { registerStoreReset } from "./stores.js";

interface PendingInvitesPanelState {
  open: boolean;
  show: () => void;
  hide: () => void;
  reset: () => void;
}

export const usePendingInvitesPanel = create<PendingInvitesPanelState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
  reset: () => set({ open: false }),
}));

// Scorch on band switch + logout — the modal must not stay painted over the next tenant or the next person.
registerStoreReset(() => usePendingInvitesPanel.getState().reset());

/** Imperative opener for non-component call sites (the router's index guard, a bell row). */
export function openPendingInvites(): void {
  usePendingInvitesPanel.getState().show();
}
